import httpService from '@/api/httpService'
import axios from 'axios'

const CancelToken = axios.CancelToken
let cancel

const CatalogApi = (() => {
  const apiPostfix = 'catalog'

  return {
    apiPostfix: apiPostfix,

    async getFolders (payload) {
      const response = await httpService.post(`${apiPostfix}/folders`, payload)
      return response.data
    },
    async getData (payload) {
      if (cancel) {
        cancel()
      }
      const response = await httpService.post(`${apiPostfix}/data`, payload, {
        cancelToken: new CancelToken(function executor (c) {
          // An executor function receives a cancel function as a parameter
          cancel = c
        })
      })
      return response.data
    },
    async getAvailableDocuments () {
      const response = await httpService.get(`${apiPostfix}/available_documents`)
      return response.data
    },
    async getCurrentDocument (payload) {
      const response = await httpService.post(`${apiPostfix}/current_document`, payload)
      return response.data
    },
    async loadOptions (payload) {
      const response = await httpService.post(`${apiPostfix}/loadOptions`, { nomenklatura_id: payload })
      return response.data
    },
    async getItemsAvailable (payload) {
      const response = await httpService.post(`${apiPostfix}/getItemsAvailable`, payload)
      return response.data
    }
  }
})()

export default CatalogApi
